
export class ScheduleHistoryModel {
    STUDENTNAME: string;
    STUDENTID: string;
    COURSECODE: string;
    COURSE: string;
    SECTION: string;
    TERM: string;
    TEACHER: string;
    SCHOOLENTRY: string;
    SCHOOLEXIT: string;
    CLASSENTRY: string;
    CLASSEXIT: string;
    USERNAME: string;
    LASTUPDATEDDATE: string;
    PERIOD: string;
}

export class ScheduleHistorySearchModel {
    classEntryDateFrom: string;
    classEntryDateTo: string;
    classExitDateFrom: string;
    classExitDateTo: string;
    lastName: string;
    firstName: string;
    studentNumber: string;
    studentListId: number;
    studentTeamId: number;
    counselorId: number;

    constructor(studentNumber: string) {
        this.classEntryDateFrom = '';
        this.classEntryDateTo = '';
        this.classExitDateFrom = '';
        this.classExitDateTo = '';
        this.lastName = '';
        this.firstName = '';
        this.studentNumber = studentNumber;
        this.studentListId = -1;
        this.studentTeamId = -1;
        this.counselorId = -1;
    }
}

